import Collapse from '@mui/material/Collapse';
import { createStyles, makeStyles } from '@mui/styles';
import { Icons } from 'copyright-clearance-center-common-ui';
import { useState } from 'react';
import { TransitionGroup } from 'react-transition-group';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'column',
			gap: '0.5rem'
		},
		buttonsContainer: {
			alignItems: 'center',
			display: 'flex',
			gap: '0.5rem',
			justifyContent: 'center'
		}
	})
);

export interface IMoreLessContainerProps {
	children: React.ReactElement[];
	step: number;
	shownChunks?: number;
	onShownChunksChange?: (shownChunks: number) => void;
	testId?: string;
}

const MoreLessContainer: React.FunctionComponent<IMoreLessContainerProps> = props => {
	const classes = useStyles();
	const [shownChunks, setShownChunks] = useState(props.shownChunks > 0 ? props.shownChunks : 1);
	const transitionTimeout = 300;
	const transitionPerTopicTimeout = transitionTimeout / props.step;

	const displayExpand = (less?: boolean): boolean => {
		return less ? shownChunks > 1 : shownChunks * props.step < props.children.length;
	};

	const getMoreLessButton = (less?: boolean) =>
		displayExpand(less) ? (
			<button
				type="button"
				className="rup-btn rup-btn--text"
				onClick={() => {
					const newShownCount = shownChunks + (less ? -1 : 1);
					if (props.onShownChunksChange) {
						props.onShownChunksChange(newShownCount);
					}

					setShownChunks(newShownCount);
				}}
				data-test-id={`${props.testId ? props.testId + '-' : ''}less-more-btn`}
				data-state={less ? 'less' : 'more'}
			>
				<span dangerouslySetInnerHTML={{ __html: less ? Icons.ChevronUpIcon : Icons.ChevronDownIcon }} />
				{localize(less ? 'Less' : 'More')}
			</button>
		) : (
			<></>
		);

	return (
		<div className={classes.root}>
			<TransitionGroup className={classes.root}>
				{[...Array(shownChunks).keys()].map(chunk => {
					const offset = props.step * chunk;
					const children = props.children.slice(offset, offset + props.step);

					return (
						<Collapse timeout={transitionPerTopicTimeout * children.length} key={chunk}>
							<div className={classes.root}>{children}</div>
						</Collapse>
					);
				})}
			</TransitionGroup>
			<div className={classes.buttonsContainer} hidden={displayExpand() || displayExpand(true)}>
				{getMoreLessButton()}
				{getMoreLessButton(true)}
			</div>
		</div>
	);
};

export default MoreLessContainer;
